import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import EntitlementsPage from "components/pages/EntitlementsPage";
import Classes from "model";
import { useEffect } from "react";

/**
 * @name CaptureEntitlements
 * @returns {React.Component}
 * @description 
 */
export default function CaptureEntitlements(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding } = context.state;

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <EntitlementsPage />;
}